import { createStore } from "vuex";
import apiBase from "../services/api/apiBase";
import cart from "./modules/cart";
import ui from "./modules/ui";
import logos from "./modules/logos";
import customizations from "./modules/customizations";
import search from "./modules/search";
import createPersistedState from "vuex-persistedstate";
import { getUser, loginUser, claimFileQuotationAndSlice } from "@/services/api";

export default createStore({
  state: {
    registration: {
      name: "",
      email: "",
      password: "",
    },
    user: {},
    authChecked: false,
    activeProfile: "Maker",
    theme: "dark",
    quoteClaims: [],
  },
  mutations: {
    setRegistration(state, payload) {
      state.registration = payload;
    },
    setUser(state, user) {
      state.user = user;
    },
    setRegisterConfirmed(state, value) {
      state.user = {
        ...state.user,
        registerConfirmed: value,
      };
    },
    setActiveProfile(state, profile) {
      state.activeProfile = profile;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    setAuthChecked(state, value) {
      state.authChecked = value;
    },
    addQuoteClaim(state, claimKey) {
      const key = String(claimKey || "").trim();
      if (!key) return;

      const current = Array.isArray(state.quoteClaims) ? state.quoteClaims : [];
      if (current.includes(key)) return;

      state.quoteClaims = [...current, key];
    },
    removeQuoteClaim(state, claimKey) {
      const key = String(claimKey || "").trim();
      if (!key) return;

      const current = Array.isArray(state.quoteClaims) ? state.quoteClaims : [];
      state.quoteClaims = current.filter((k) => k !== key);
    },
    clearQuoteClaims(state) {
      state.quoteClaims = [];
    },
  },

  actions: {
    async loginUser({ dispatch }, { email, password }) {
      await loginUser(email, password);
      return await dispatch("loginUserByToken");
    },

    async loginUserByToken({ commit, dispatch, state }) {
      const resp = await getUser();
      const user = resp.data;

      const keys = Array.isArray(state.quoteClaims)
        ? [...state.quoteClaims]
        : [];
      const hadQuoteClaims = keys.length > 0;

      commit("setUser", user);

      for (const claimKey of keys) {
        try {
          await claimFileQuotationAndSlice({ claimKey });
          commit("removeQuoteClaim", claimKey);
        } catch (e) {
          console.warn(
            "Falha ao reivindicar cotação por claimKey:",
            claimKey,
            e,
          );
        }
      }

      try {
        await dispatch("cart/fetchSummary", null, { root: true });
      } catch (e) {
        console.warn("Erro ao buscar os dados do carrinho:", e);
      } finally {
        commit("setAuthChecked", true);
      }

      return { user, hadQuoteClaims };
    },

    async logout({ commit }) {
      try {
        await apiBase.post("/auth/logout");
      } catch (e) {
        console.warn("Falha ao fazer logout:", e);
      }

      commit("setUser", {});
      commit("setAuthChecked", true);
      commit("cart/RESET_CART", null, { root: true });
      commit("customizations/RESET_CUSTOMIZATIONS", null, { root: true });
      commit("logos/RESET_LOGOS", null, { root: true });
      commit("clearQuoteClaims");
    },

    toggleTheme({ commit, state }) {
      const newTheme = state.theme === "dark" ? "light" : "dark";
      commit("setTheme", newTheme);
    },
  },
  getters: {
    registrationData: (state) => state.registration,
    activeProfile: (state) => state.activeProfile,
    quoteClaims: (state) => state.quoteClaims,
  },
  modules: {
    cart,
    ui,
    logos,
    customizations,
    search,
  },
  plugins: [
    createPersistedState({
      key: "mm:ps",
      paths: [
        "theme",
        "activeProfile",
        "cart.summary",
        "logos",
        "customizations",
        "quoteClaims",
      ],
    }),
  ],
});
